<template>
    <layout class="Reporttxt">
        <div class="row space-between">
            <pair label="姓名" :value="data.hospital_patient_name" />
            <pair label="年龄" :value="age" />
            <pair label="性别" :value="data.hospital_patient_sex" />
        </div>
        <div class="row space-between">
            <pair label="床号" :value="data.hospital_patient_bedno" />
            <pair label="住院号" :value="data.hospital_patient_homeno" />
        </div>
        <div class="row space-between">
            <pair label="送诊科室" :value="data.hospital_send_department" />
            <pair label="送诊医生" :value="data.hospital_check_doctor" />
        </div>
        <div class="split"></div>
        <div class="title">{{data.Modality || '检查'}}所见:</div>
        <div class="txt">{{data.hospital_patient_video || '无'}}</div>
        <div class="split"></div>
        <div class="title">{{data.Modality || '意见'}}诊断：</div>
        <div class="txt">{{data.hospital_patient_videodesc || '无'}}</div>
        <div class="blue" @click="toMovie(is_open_dicom_processing?true:false)">{{is_open_dicom_processing?'查阅电子胶片':'查阅影像'}}</div>
        <div class="row space-between">
            <pair label="报告医生" :value="data.hospital_doctor_name" />
            <pair label="审核医生" :value="data.hospital_check_docname" />
        </div>
        <div class="row space-between">
            <pair label="报告生成时间" :value="data.hospital_generate_time" />
        </div>
      <popup :show.sync="noElectronShow">
        <div class="noelectron-box" v-show="noElectronShow">
          <div class="close" @click="noElectronShow=false">X</div>
          <div v-if="entity_film_print" class="text">您已打印塑料胶片<br/>电子胶片功能已关闭</div>
          <div v-else class="text">暂无电子胶片<br/>请查看原始影像</div>
        </div>
      </popup>
    </layout>
</template>

<script>
import layout from '../Report/layout'
import data from '@/views/data'
import popup from '../Report/pupup'
import { Toast } from 'vant';
import QRCode from 'qrcodejs2'
import { getInformation, getAccessKey } from "@/api/api";
export default {
    components: {
        layout,
        popup,
        pair: {
            props: {
                label: {type: String, default: ''},
                value: {type: [String, Number], default: ''},
            },
            render () {
                return <div class="pair row-margin0">
                    <span class="label">{this.label}</span>
                    <span class="value">{this.value || '无'}</span>
                </div>
            }
        }
    },
    data(){
      return {
        noElectronShow: false,
      }
    },
    methods: {
        toMovie(bElectronMovie) {
            if(this.entity_film_print){
              this.noElectronShow = true;
              return;
            }
            if(bElectronMovie && !this.data.is_add_dicom_processing){
              this.noElectronShow = true;
              return;
            }
            data.urrl(bElectronMovie?1:0)
        },
    },
    computed: {
        is_open_dicom_processing () {
          return this.data && this.data.is_open_dicom_processing==1;
        },
        entity_film_print () {
          return this.data && this.data.entity_film_print==1;
        },
        data () {
            return data.data
        },
        date () {
            return this.data.hospital_check_time ? this.data.hospital_check_time.split(' ')[0] : ''
        },
        age () {
            return this.data.hospital_patient_age ? this.data.hospital_patient_age.split(' ')[0] : ''
        },
        AccessionNumber () {
            return data.AccessionNumber
        },
        key () {
            return data.key
        },
        house_id () {
            return data.house_id
        },
        password() {
            return data.password
        }
    },
    mounted () {
        data.getData()
    }
}
</script>